export default __webpack_public_path__ + "static/media/248.19b4e3e1.png";